module.exports = __webpack_public_path__ + "img/p2-72.0a2e9719.png";